import XLSX from "xlsx";
import Swal from "sweetalert2";

export function readWarehouseData(data) {
  const workbook = XLSX.read(data, { type: "buffer" });
  const wsname = workbook.SheetNames[0];
  const ws = workbook.Sheets[wsname];
  const sheetData = XLSX.utils.sheet_to_json(ws, { header: 1 });
  let warehouseData = [];
  for (let i = 5; i < sheetData.length; i++) {
    if (sheetData[i][5] && sheetData[i][2]) {
      warehouseData.push({
        id: sheetData[i][2],
        value: sheetData[i][5],
      });
    }
  }
  return warehouseData;
}

export function messageInfo(text) {
  this.$notify({
    timeout: 3000,
    type: "info",
    message: text,
    icon: "add_alert",
    horizontalAlign: "center",
    verticalAlign: "top",
  });
}
export function messageSuccess(text) {
  this.$notify({
    timeout: 3000,
    type: "success",
    message: text,
    icon: "add_alert",
    horizontalAlign: "right",
    verticalAlign: "top",
  });
}
export function messageError(text) {
  this.$notify({
    timeout: 3000,
    type: "danger",
    message: text,
    icon: "add_alert",
    horizontalAlign: "right",
    verticalAlign: "top",
  });
}
export function confirm(text, title) {
  return Swal.fire({
    title: title,
    text: text,
    type: "warning",
    showCancelButton: true,
    confirmButtonClass: "md-button md-success",
    cancelButtonClass: "md-button md-danger",
    confirmButtonText: "OK",
    buttonsStyling: false,
  });
}
